import styled from 'styled-components'

export const ProductContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props.templateColumns};
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.info.surface};
  border-radius: ${props => props.theme.primitives.radius.radius4};
  padding: ${props => props.theme.spacing.sp8};
`
